import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetInspectionChecklistItemEvidenceMutationVariables = Types.Exact<{
  itemId: Types.Scalars['uuid']['input'];
  status: Types.Scalars['String']['input'];
}>;


export type ResetInspectionChecklistItemEvidenceMutation = { __typename?: 'mutation_root', delete_evidence_findings?: { __typename?: 'evidence_findings_mutation_response', affected_rows: number } | null, delete_evidence_submissions?: { __typename?: 'evidence_submissions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'evidence_submissions', id: any, file_url: string }> } | null, update_inspection_checklist_items_by_pk?: { __typename?: 'inspection_checklist_items', id: any, status?: string | null } | null };


export const ResetInspectionChecklistItemEvidenceDocument = gql`
    mutation resetInspectionChecklistItemEvidence($itemId: uuid!, $status: String!) {
  delete_evidence_findings(where: {checklist_item_id: {_eq: $itemId}}) {
    affected_rows
  }
  delete_evidence_submissions(where: {checklist_item_id: {_eq: $itemId}}) {
    affected_rows
    returning {
      id
      file_url
    }
  }
  update_inspection_checklist_items_by_pk(
    pk_columns: {id: $itemId}
    _set: {status: $status}
  ) {
    id
    status
  }
}
    `;
export type ResetInspectionChecklistItemEvidenceMutationFn = Apollo.MutationFunction<ResetInspectionChecklistItemEvidenceMutation, ResetInspectionChecklistItemEvidenceMutationVariables>;

/**
 * __useResetInspectionChecklistItemEvidenceMutation__
 *
 * To run a mutation, you first call `useResetInspectionChecklistItemEvidenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetInspectionChecklistItemEvidenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetInspectionChecklistItemEvidenceMutation, { data, loading, error }] = useResetInspectionChecklistItemEvidenceMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useResetInspectionChecklistItemEvidenceMutation(baseOptions?: Apollo.MutationHookOptions<ResetInspectionChecklistItemEvidenceMutation, ResetInspectionChecklistItemEvidenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetInspectionChecklistItemEvidenceMutation, ResetInspectionChecklistItemEvidenceMutationVariables>(ResetInspectionChecklistItemEvidenceDocument, options);
      }
export type ResetInspectionChecklistItemEvidenceMutationHookResult = ReturnType<typeof useResetInspectionChecklistItemEvidenceMutation>;
export type ResetInspectionChecklistItemEvidenceMutationResult = Apollo.MutationResult<ResetInspectionChecklistItemEvidenceMutation>;
export type ResetInspectionChecklistItemEvidenceMutationOptions = Apollo.BaseMutationOptions<ResetInspectionChecklistItemEvidenceMutation, ResetInspectionChecklistItemEvidenceMutationVariables>;